export enum CreatePermanentJobPostingSteps {
  BasicInformation = 'basic-information',
  JobDescription = 'job-description',
  ReviewAndPayment = 'review-and-payment',
  WorkDetails = 'work-details',
}

/**
 * Route pattern for the Copy & Paste (import job description) flow's Confirm Job Details
 * step. It is id-based like the manual guided-form routes so the page can hydrate from a
 * draft and continue into the shared Review & Payment step.
 */
export const IMPORT_CONFIRM_JOB_DETAILS_PATH = '/permanent-jobs/postings/:id/confirm-job-details';

/** Build the Confirm Job Details path for a parsed draft posting id. */
export const buildImportConfirmJobDetailsPath = (id: string) =>
  `/permanent-jobs/postings/${id}/confirm-job-details`;

export enum CreatePermanentJobPostingFormSection {
  EarningsAndBenefits = 'earnings-and-benefits',
  GeneralJobInformation = 'general-job-information',
  JobDescription = 'job-description',
  Schedule = 'schedule',
}

export type TCreatePermanentJobPostingPageRoutes = { id?: string };

export type TCreatePermanentJobPostingPageLocationState = {
  editMode?: boolean;
  scrollTo?: CreatePermanentJobPostingFormSection;
  /**
   * Set when Review & Payment is entered from the Copy & Paste import flow's Confirm
   * Job Details page. Switches the stepper to the 3-step import variant and lets "Back"
   * return to Confirm Details without the exit-confirmation prompt.
   */
  fromImport?: boolean;
};
